var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.53846C7.32682 3.53846 3.53846 7.32682 3.53846 12C3.53846 16.6732 7.32682 20.4615 12 20.4615C16.6732 20.4615 20.4615 16.6732 20.4615 12C20.4615 7.32682 16.6732 3.53846 12 3.53846ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.2308 7.89744C11.2308 7.4726 11.5752 7.12821 12 7.12821H12.0103C12.4351 7.12821 12.7795 7.4726 12.7795 7.89744C12.7795 8.32227 12.4351 8.66667 12.0103 8.66667H12C11.5752 8.66667 11.2308 8.32227 11.2308 7.89744ZM10.2051 12C10.2051 11.5752 10.5495 11.2308 10.9744 11.2308H12C12.4248 11.2308 12.7692 11.5752 12.7692 12V15.3333H13.0256C13.4505 15.3333 13.7949 15.6777 13.7949 16.1026C13.7949 16.5274 13.4505 16.8718 13.0256 16.8718H12C11.5752 16.8718 11.2308 16.5274 11.2308 16.1026V12.7692H10.9744C10.5495 12.7692 10.2051 12.4248 10.2051 12Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeInfo);
export default __webpack_public_path__ + "static/media/large-info.7d04021c5811f46bf71a8f919f8bdd86.svg";
export { ForwardRef as ReactComponent };